var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIconFadeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "20px",
    viewBox: "0 0 20 20",
    width: "20px",
    fill: "#666666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "4.59,16.59 6,18 14,10 6,2 4.59,3.41 11.17,10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIconFadeColor);
export default __webpack_public_path__ + "static/media/rightArrowIconFadeColor.d00201d5d5bbfb9029588323ba32e14c.svg";
export { ForwardRef as ReactComponent };